import { SyntheticEvent, useState, useEffect } from 'react';
import { CoreBox } from '@youscience/core';
import { Tabs } from '@mui/material';
import { Roles, RoleEnum } from '@youscience/commonapp-service-common';

import Table from '@pages/RecommenderSpace/components/Table';

import useRecommenderWorkspaceStore from '@store/RecommenderWorkspaceStore';
import useCommonAppAdminStore from '@store/CommonAppAdminStore';

import ScrollToTopButton from '@components/ScrollToTopButton';

import { sxStyles, StyledTab } from './UserRolesTab.styles';

const ROLE_BY_MODE: Record<number, RoleEnum> = {
  0: Roles.COUNSELOR,
  1: Roles.TEACHER,
};

export const UserRolesTab = () => {
  const [pageMode, setPageMode] = useState(0);

  const { userRoles } = useCommonAppAdminStore((store) => store);
  const { applicantFormsAvailable, getApplicantFormsAvailable } = useRecommenderWorkspaceStore((store) => store);

  const isTeacherRole = userRoles?.includes(Roles.TEACHER);
  const isCounselorRole = userRoles?.includes(Roles.COUNSELOR);
  const isBothRoles = isTeacherRole && isCounselorRole;

  const handleTabChange = (event: SyntheticEvent, newValue: number) => {
    setPageMode(newValue);
  };

  useEffect(() => {
    if (isBothRoles) {
      void getApplicantFormsAvailable(ROLE_BY_MODE[pageMode]);
    } else if (userRoles) {
      void getApplicantFormsAvailable(userRoles[0]);
    }
  }, [pageMode, userRoles]);

  return (
    <CoreBox sx={sxStyles.bg}>
      {isTeacherRole && isCounselorRole ? (
        <Tabs value={pageMode} onChange={handleTabChange}>
          <StyledTab label="Counselor reports" />

          <StyledTab label="Teacher evaluations" />
        </Tabs>
      ) : null}

      {(isBothRoles && pageMode === 0) || (isCounselorRole && !isTeacherRole) ? (
        <CoreBox sx={sxStyles.tableWrap}>
          <Table tableData={applicantFormsAvailable?.applicantFormRequests} role={Roles.COUNSELOR} />
        </CoreBox>
      ) : null}

      {(isBothRoles && pageMode === 1) || (isTeacherRole && !isCounselorRole) ? (
        <CoreBox sx={sxStyles.tableWrap}>
          <Table tableData={applicantFormsAvailable?.applicantFormRequests} role={Roles.TEACHER} />
        </CoreBox>
      ) : null}

      <ScrollToTopButton />
    </CoreBox>
  );
};
